import { TenderStatus } from '../components/data-components/pickers/TenderPicker/TenderPicker'
import { EMPTY_USER, User } from './users'
import { EMPTY_TASK_TYPE, TaskType } from './refs/refs'
import { ServerProject } from './projects'
import { ID, UpdateData } from '../types/UtilityTypes'
import { TaskStatus } from '../constants/enums'
import { ProjectWorkObject } from './objects'
import { Comment, CommentData, CommentRequestData } from './comments'
import { Colors } from '../styles'
import { enumMatchAll } from '../utils/enum-utils'

export type UpdateTaskRequest = UpdateData<Task> & {
    comment?: CommentRequestData,
}

export interface Task {
    id: ID,
    parent_id: ID,
    project_code?: string,
    tender_id: TenderStatus,
    priority_id: number,
    status_id: TaskStatus,
    deadline_at: string,
    deadline: string,
    deadline_type: string,
    deleted_at?: string,
    target_user: User | null,
    tendered_user: User | null,
    users: User[],
    type: TaskType,
    type_id?: ID,
    project_work_object_id: number,
    unread_history: number,
    details: {
        user_id: number,
        owner_id?: number,
        owner_type?: string,
        created_at: string,
        comment?: Comment,
        user: User,
    }
}

export interface ServerTask extends Task {
    children?: ServerTask[],
    project: ServerProject,
    project_work_object: ProjectWorkObject,
    results: Comment[],
}

export const EMPTY_TASK: Task = {
    deadline_at: '',
    deadline: '',
    deadline_type: '',
    id: 0,
    parent_id: 0,
    priority_id: 1,
    status_id: TaskStatus.REQUESTED,
    target_user: null,
    tendered_user: null,
    users: [],
    tender_id: TenderStatus.CANCELED,
    type: EMPTY_TASK_TYPE,
    project_work_object_id: 0,
    unread_history: 0,
    details: {
        user_id: 0,
        created_at: '',
        user: EMPTY_USER,
    }
}

export type PartialTask = Partial<Task> & {
    comment?: CommentData,
}

export type AbstractQuery = ID[] | ID | 'null'

export interface TaskListQuery {
    tasks_type?: AbstractQuery,
    tasks_target_user?: AbstractQuery,
    tasks_status?: AbstractQuery,
}

export const taskStatusToColor = enumMatchAll<TaskStatus>()({
    [TaskStatus.ALL]: Colors.grey,
    [TaskStatus.REQUESTED]: Colors.orange,
    [TaskStatus.OPENED]: Colors.blue,
    [TaskStatus.CLOSED]: Colors.green,
})

export type TaskRecord = Record<ID, Task>